import dynamic from 'next/dynamic';
const CompanyStats = dynamic(() => import('./CompanyStats'));
export default CompanyStats;
